import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { throttle } from "lodash"

import SEOCTAFooter from "containers/SEOCTAFooter/SEOCTAFooter"

import { setWindowHeight, setDocumentHeight, scroll } from "actions/ui"

import styles from "./deviceWrapper.css"

@connect(state => ({
  displayCookieBanner: state.privacy.displayCookieBanner,
  ui: state.ui,
}))
export default class DeviceWrapper extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    dispatch: PropTypes.func.isRequired,
    displayCookieBanner: PropTypes.bool,
    downloadText: PropTypes.string,
    ui: PropTypes.object.isRequired,
  }

  watchScroll = () => {
    this.props.dispatch(scroll(window.scrollY))
  }

  watchResize = () => {
    this.props.dispatch(setWindowHeight(window.innerHeight))

    const body = document.body
    const html = document.documentElement
    const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    this.props.dispatch(setDocumentHeight(height))
  }

  constructor(props) {
    super(props)
    this.watchResize = throttle(this.watchResize, 200)
    this.watchScroll = throttle(this.watchScroll, 10) // low time to prevent glitches
  }

  componentDidMount() {
    window.addEventListener("resize", this.watchResize)
    window.addEventListener("scroll", this.watchScroll)
  }

  componentDidUpdate() {
    this.watchResize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.watchResize)
    window.removeEventListener("scroll", this.watchScroll)
  }

  render() {
    const {
      children,
      displayCookieBanner,
      downloadText,
      ui: { documentHeight, footerHeight, scrollTop, windowHeight },
    } = this.props

    const footerStyle = {
      transition: "none",
    }

    if (scrollTop + windowHeight > documentHeight - footerHeight) {
      const offset = footerHeight - (documentHeight - (scrollTop + windowHeight)) - 2
      footerStyle.bottom = offset
    }

    const buttonText = downloadText && (
      <div>
        <span className={styles.hiddenMobile}>{downloadText}</span>
        <span className={styles.hiddenDesktop}>Télécharger l'App</span>
      </div>
    )

    return (
      <div>
        {children}
        {buttonText && <SEOCTAFooter customStyle={footerStyle} visible={!displayCookieBanner} buttonText={buttonText} redirectToApp={true} />}
      </div>
    )
  }
}
